import React from 'react';

const ContactInfo = () => {
  return (
    <>
      {/* Breadcrumb */}
      <div
        className="breadcumb-wrapper"
        data-overlay="black"
        data-opacity="3"
      >
        <div className="container">
          <div className="breadcumb-content text-center">
            <h1 className="breadcumb-title">Contact Us</h1>
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div className="contact-area-2 space-top" id="contact-sec">
        <div className="container">
          <div className="title-area text-center">
            <h2 className="sec-title">Our Contact Information</h2>
          </div>

          <div className="row gy-4 justify-content-center">

            {/* Mobile Numbers */}
            <div className="col-xl-4 col-lg-6 contact-feature-wrap">
              <div className="contact-feature">
                <div className="contact-feature-icon">
                  <i className="fa-solid fa-phone"></i>
                </div>
                <div className="media-body">
                  <p className="contact-feature_label">Mobile Numbers</p>
                  <a href="tel:+919209423113" className="contact-feature_link">
                    +91 92094 23113
                  </a>
                  <a href="tel:+917620411277" className="contact-feature_link">
                    +91 76204 11277
                  </a>
                  <a href="tel:+919284718314" className="contact-feature_link">
                    +91 92847 18314
                  </a>
                </div>
              </div>
            </div>

            {/* Email */}
            <div className="col-xl-4 col-lg-6 contact-feature-wrap ">
              <div className="contact-feature ">
                <div className="contact-feature-icon">
                  <i className="fa-solid fa-envelope"></i>
                </div>
                <div className="media-body ">
                  <p className="contact-feature_label">Email Address</p>
                  <a
                    href="mailto:booking@urbaniaonrentpune.in"
                    className="contact-feature_link"
                  >
                    booking@urbaniaonrentpune.in
                  </a>
                </div>
              </div>
            </div>

            {/* Address */}
            <div className="col-xl-4 col-lg-6 contact-feature-wrap">
              <div className="contact-feature">
                <div className="contact-feature-icon">
                  <i className="fa-solid fa-location-dot"></i>
                </div>
                <div className="media-body">
                  <p className="contact-feature_label">Our Address</p>
                  <a
                    href="https://www.google.com/maps?q=Vrindavan+Society+Rd,+Deshmukh+Nagar,+Shivane,+Pune"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-feature_link"
                  >
                    Pune Urbania On Rent<br />
                    Vrindavan Society Rd,<br />
                    Deshmukh Nagar, Shivane,<br />
                    Pune, Maharashtra – 411023
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Google Map */}
      <div className="space-top">
        <div className="container-fluid p-0">
          <div className="contact-map">
          

<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3784.4280425670886!2d73.7834455!3d18.4642606!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc29500276bffe3%3A0xd62d5cee62c2dcd8!2sUrbania%20on%20rent%20in%20pune!5e0!3m2!1sen!2sin!4v1766664154033!5m2!1sen!2sin" width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

          </div>
        </div>
      </div>
    </>
  );
};

export default ContactInfo;
